import { create } from 'zustand';
import type { XYPosition } from '@xyflow/react';

interface ObservabilityGraphState {
  positions: Record<string, XYPosition>;
  setPositions: (positions: Record<string, XYPosition>) => void;
  clearPositions: () => void;
}

export const useObservabilityGraphStore = create<ObservabilityGraphState>((set) => ({
  positions: {},
  setPositions: (positions) =>
    set((state) => {
      const hasChanges = Object.entries(positions).some(([id, position]) => {
        const current = state.positions[id];
        return !current || current.x !== position.x || current.y !== position.y;
      });
      return hasChanges ? { positions: { ...state.positions, ...positions } } : state;
    }),
  clearPositions: () => set({ positions: {} }),
}));
